export default __webpack_public_path__ + "img/2e50b3d2b06035e59fdc9c90f4bdc90a.png";